'use strict';

var _ = require('lodash');

function ButtonController () {
  var DEFAULTS = {
    disabled: false,
    loading: false,
    loadingLabel: null,
    icon: '',
    iconPosition: '',
    iconShape: '',
    label: '',
    show: true,
    showLabel: true,
    size: 'medium',
  };

  var vm = this;
  _.defaults(vm, DEFAULTS);

  vm.init = function () {};

  vm.getAttr = function (attr) {
    return function () {
      return vm[attr];
    };
  };

  vm.getButtonClasses = function () {
    var classes = [];

    // add size
    classes.push(vm.size);

    if (vm.label) {
      classes.push('has-label');
    }

    if (vm.icon) {
      classes.push('has-icon');
    }

    // add icon position class
    if (vm.getIconPosition()) {
      classes.push(vm.getIconPosition());
    }

    if (vm.iconShape) {
      classes.push(vm.iconShape);
    }

    return classes.join(' ');
  };

  vm.getIconPosition = function () {
    var pos = '';

    if (vm.icon && vm.iconPosition) {
      pos = 'icon-' + vm.iconPosition;
    } else if (vm.icon && vm.label && !vm.iconPosition) {
      pos = 'icon-left';
    }

    return pos;
  };
}

module.exports = ButtonController;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/button/src/button/ButtonController.js